import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

import {Constants} from '../config/constants.config';
import {InfluencerViewModel} from '../viewModels/stars.viewModel';
import {RecipeViewModalModel} from '../viewModels/recipe.viewModel';

@Injectable()
export class StarsService {

    constructor(
        private readonly httpClient: HttpClient,
        private readonly constants: Constants
    ) {
    }

    getInfluencers(): Observable<InfluencerViewModel[]> {
        return this.httpClient.get<InfluencerViewModel[]>(`${this.constants.apiURL()}/website/influencers/`);
    }

    getInfluencerById(id): Observable<InfluencerViewModel> {
        return this.httpClient.post<InfluencerViewModel>(`${this.constants.apiURL()}/website/influencers/`, {
            id: id
        });
    }

    getRecipesByInfluencerId(id): Observable<RecipeViewModalModel[]> {
        return this.httpClient.get<RecipeViewModalModel[]>(`${this.constants.apiURL()}/website/recipes/by/influencer/${id}/`);
    }

    isInfluencerInSubscription(influencer_id): Observable<void> {
        return this.httpClient.post<void>(`${this.constants.apiURL()}/subscription/addon/${influencer_id}/`, {});
    }

    removeInfluencerFromSubscription(influencer_id): Observable<void> {
        return this.httpClient.delete<void>(`${this.constants.apiURL()}/subscription/addon/${influencer_id}/`, {});
    }

}
